module.exports = __webpack_public_path__ + "img/baby-boy.2423af61.svg";